import { PaymentIntent } from '@ravago/shared/page-data/models/features';

import { PaymentIntentCreateBlockedError } from '../../lib/errors/payment-intent-create-blocked-error';
import { handleApiError } from '../../lib/utils/error-handler/error-handler';

export abstract class PaymentUtils {
  static async getPublishableKey(legalEntityId: string): Promise<{ stripePublishableKey: string }> {
    const response = await fetch(`/api/stripe/publishable-keys/${legalEntityId}`, {
      method: 'GET'
    });
    if (!response.ok) handleApiError(response);
    return response.json();
  }

  static async getPaymentIntent(id: number): Promise<PaymentIntent> {
    const response = await fetch(`/api/customer/payment-intents/${id}`, {
      method: 'GET'
    });
    if (!response.ok) handleApiError(response);
    return response.json();
  }

  static async createPaymentIntent(transactionIds: string[]): Promise<PaymentIntent> {
    const response = await fetch(`/api/customer/payment-intents`, {
      method: 'POST',
      body: JSON.stringify({ transactionIds })
    });

    if (!response.ok) {
      if (response.status === 409) {
        const errorData: { code: string; message: string } = await response.json();
        if (errorData.code === 'DP-001') throw new PaymentIntentCreateBlockedError();
      }
      handleApiError(response);
    }
    return response.json();
  }

  static async setPaymentIntentStatus(id: number): Promise<boolean> {
    const response = await fetch(`/api/customer/payment-intents/${id}/statuses`, {
      method: 'POST'
    });

    return response.ok;
  }
}
